import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HeaderService } from '../header/header.service';
import { User } from '../../api/models/user-model';
import { AuthService } from '../../api/services/auth.service';
import { UserService } from '../../api/services/user.service';
import { AvatarService } from '../services/avatar.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { PreferencesService } from '../../api/services/preferences.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private avatarService: AvatarService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private headerService: HeaderService,
    private modalService: NgbModal,
    private preferencesService: PreferencesService
  ) { }

  profileForm: FormGroup;

  hasProfileImage = false;
  loaded = false;
  user: User;
  profileImageUrl: string;
  avatarImg = '/assets/images/avatar-profile-image.png';

  onProfileImageUploaded(id: string) {
    this.avatarService.saveAvatar(this.user['User ID'], id)
      .subscribe(() => {
        this.onUpdateSuccess();
        this.headerService.refreshHeaderProfileImage();
      });
    this.avatarService.getAvatarByFileId(id)
      .subscribe(this.onAvatarSubscription.bind(this));
  }

  removeProfileImage() {
    this.avatarService.removeAvatar(this.user['User ID'])
      .subscribe(() => {
        this.hasProfileImage = false;
        this.headerService.refreshHeaderProfileImage();
        this.onUpdateSuccess();
      });
  }

  changePassword() {
    const modalRef = this.modalService.open(ChangePasswordComponent, {
      backdrop : 'static',
      keyboard : false
    });
    modalRef.componentInstance.userId = this.user['User ID'];

    modalRef.result.then(() => {
      this.toastr.success('Password changed!!!', 'Succcess!', {
        timeOut: 1000,
        positionClass: 'toast-bottom-right'
      });

    })
      .catch(() => { });
  }

  private onAvatarSubscription(url: string) {
    if (url) {
      this.hasProfileImage = true;
      this.profileImageUrl = url;
    }
  }

  private onUpdateSuccess() {
    this.toastr.success('Profile saved!!!', 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  ngOnInit() {
    this.userService.findUserById(this.authService.getUserId())
      .subscribe((user: User) => {
        this.user = user;

        this.preferencesService.getPreferences('USER', this.user['User ID']).subscribe(prefs => {
          this.user.Company = prefs['company'].Value;
          this.user.Position = prefs['position'].Value;

          this.loaded = true;

          this.profileForm = this.formBuilder.group({
            'First Name': [user['First Name'], Validators.required],
            'Last Name': [user['Last Name'], Validators.required],
            'Email Address': [user['Email Address'], [Validators.required, Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)]],
            'SMS Phone Number': [user['SMS Phone Number'], Validators.required],
            Company: [user.Company],
            Position: [user.Position],
            isAdmin: [user.isAdmin]
          });

          this.profileForm
            .valueChanges
            .filter(x => this.profileForm.valid)
            .debounceTime(500)
            .distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b))
            .subscribe(form => {
              Object.assign(this.user, form);
              this.userService.saveUser(this.user)
                .subscribe(() => {
                  this.preferencesService.setPreference('USER', this.user['User ID'], 'company', { Value: this.user.Company }).subscribe();
                  this.preferencesService.setPreference('USER', this.user['User ID'], 'position', { Value: this.user.Position })
                    .subscribe();
                  this.onUpdateSuccess();
                });
            });

          this.avatarService.getAvatarByUserId(this.user['User ID'])
            .subscribe(this.onAvatarSubscription.bind(this));

        });
      });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/profile/profile.component.ts